import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Success from "./Success";
import Cancel from "./Cancel";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/order/success" element={<Success />} />
        <Route path="/order/cancel" element={<Cancel />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
